export default "__VITE_ASSET__Cx_tmKyd__"